import logo0 from '../assets/trainers/login/logo_0.webp';
import logo1 from '../assets/trainers/login/logo_1.webp';
import calendarCheerful0 from '../assets/trainers/calendar/calendar_cheerful_0.webp';
import calendarCheerful1 from '../assets/trainers/calendar/calendar_cheerful_1.webp';
import calendarDepressed0 from '../assets/trainers/calendar/calendar_depressed_0.webp';
import calendarDepressed1 from '../assets/trainers/calendar/calendar_depressed_1.webp';
import calendarNormal0 from '../assets/trainers/calendar/calendar_normal_0.webp';
import calendarNormal1 from '../assets/trainers/calendar/calendar_normal_1.webp';
import practice30 from '../assets/trainers/practice/practice_3_0.webp';
import practice31 from '../assets/trainers/practice/practice_3_1.webp';
import endPractice0 from '../assets/trainers/practice/end_practice_0.webp';
import endPractice1 from '../assets/trainers/practice/end_practice_1.webp';

export const TRAINERS = {
  0: { id: 0, name: 'Min', gender: 'male' },
  1: { id: 1, name: 'Mina', gender: 'female' },
  3: { id: 3, name: 'Robot Trainer', gender: 'robot' },
};

const LOGIN_LOGOS = {
  0: logo0,
  1: logo1,
};

const CALENDAR_IMAGES = {
  cheerful: {
    0: calendarCheerful0,
    1: calendarCheerful1,
  },
  depressed: {
    0: calendarDepressed0,
    1: calendarDepressed1,
  },
  normal: {
    0: calendarNormal0,
    1: calendarNormal1,
  },
};

const EARLY_GRADE_THREE_IMAGES = {
  0: practice30,
  1: practice31,
};

const END_PRACTICE_IMAGES = {
  0: endPractice0,
  1: endPractice1,
};

function getKoreaWeekday(date = new Date()) {
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Seoul',
    weekday: 'short',
  }).format(date);
}

export function getCurrentTrainerId(date = new Date()) {
  const weekday = getKoreaWeekday(date);
  return ['Fri', 'Sat', 'Sun'].includes(weekday) ? 1 : 0;
}

export function getCurrentTrainer(date = new Date()) {
  const trainerId = getCurrentTrainerId(date);
  return TRAINERS[trainerId] || TRAINERS[0];
}

export function getLoginLogo(date = new Date()) {
  const trainerId = getCurrentTrainerId(date);
  return LOGIN_LOGOS[trainerId] || LOGIN_LOGOS[0];
}

export function getCalendarImage(status = 'normal', date = new Date()) {
  const trainerId = getCurrentTrainerId(date);
  const normalizedStatus = CALENDAR_IMAGES[status] ? status : 'normal';
  return CALENDAR_IMAGES[normalizedStatus][trainerId] || CALENDAR_IMAGES.normal[0];
}

export function getEarlyGradeThreeTrainerImage(trainer_Id = getCurrentTrainerId()) {
  const trainerId = Number.isInteger(trainer_Id) && trainer_Id >= 0 ? trainer_Id : 0;
  return EARLY_GRADE_THREE_IMAGES[trainerId] || EARLY_GRADE_THREE_IMAGES[0];
}

export function getEndPracticeImage(date = new Date()) {
  const trainerId = getCurrentTrainerId(date);
  return END_PRACTICE_IMAGES[trainerId] || END_PRACTICE_IMAGES[0];
}

const TrainerAssets = {
  TRAINERS,
  getCurrentTrainerId,
  getCurrentTrainer,
  getLoginLogo,
  getCalendarImage,
  getEarlyGradeThreeTrainerImage,
  getEndPracticeImage,
};

export default TrainerAssets;
